<ul *ngIf="(control?.touched || control?.dirty) && control?.invalid">
  <li *ngFor="let error of errorList$ | async">
    <ion-text color="danger">{{ error.message }}</ion-text>
  </li>
</ul>
